const Footer = () =>{
    return(
        <footer>
            <div className="logo-item">
                <img src="images/logo2222.png" alt="" />
                <h4>Best way to go <span>green....</span></h4>
                <h3>About Us</h3>
                <p>Lorem ipsum dolor sit amet consectetur <br /> adipisicing elit.  Nisi perferendis nostrum eos veniam similique  <br />repellendus ratione debitis necessitatibus.</p>
            </div>

            <div className="logo-item1">
                    <h1>Informations</h1>
                    <ul>
                        <li>About Us</li>
                        <li>More search</li>
                        <li>Blog</li>
                        <li>Testimonials</li>
                        <li>Events</li>
                    </ul>
            </div>
            <div className="logo-item">
                    <h1>Helpful links</h1>
                    <ul>
                        <li>Services</li>
                        <li>Supports</li>
                        <li>Terms and conditions</li>
                        <li>Privacy Policy</li>
                        
                    </ul>
            </div>
        
        </footer>
    )
}


export default Footer